module.exports = __webpack_public_path__ + "static/media/Category.svg";